const currentYear = new Date().getFullYear();

const getSeoCategoryWithVariables = (
  seoObject,
  categoryName,
  subCategoryName,
  systemCount,
  country
) => {
  const newObject = {};

  Object.entries(seoObject).forEach(([key, value]) => {
    if (typeof value !== 'string') {
      return;
    }

    let newValue = value;
    newValue = newValue.replaceAll(/{{categoryName}}/g, categoryName);
    newValue = newValue.replaceAll(/{{subCategoryName}}/g, subCategoryName);
    newValue = newValue.replaceAll(/{{systemCount}}|{{cn}}/g, systemCount);
    newValue = newValue.replaceAll(/{{country}}/g, country);
    newValue = newValue.replaceAll(/{{year}}/g, currentYear);

    newObject[key] = newValue;
  });

  return newObject;
};

export default function useGetSeoCategory({
  categoryData,
  categoryDefaultData,
  subCategoryData = {},
  systemCount,
  country,
  siteUrl,
}) {
  const {
    seo: seoCategory,
    categoryName,
    slugi18n: categorySlug,
  } = categoryData;

  const {
    seoCategory: seoCategoryDefault,
    seoSubCategory: seoSubCategoryDefault,
  } = categoryDefaultData;

  // Create a new object with the metaTitle and metaDescription
  const newSeoCategory = {
    metaTitle: seoCategory?.metaTitle || seoCategoryDefault?.metaTitle,
    metaDescription:
      seoCategory?.metaDescription || seoCategoryDefault?.metaDescription,
  };

  const {
    seo: subCategorySeo = '',
    name: subCategoryName = '',
    slugi18n: subCategorySlug,
  } = subCategoryData;

  const newSeoSubCategory = {
    metaTitle: subCategorySeo?.metaTitle || seoSubCategoryDefault?.metaTitle,
    metaDescription:
      subCategorySeo?.metaDescription || seoSubCategoryDefault?.metaDescription,
  };

  // Replace all variables within title and description
  const fixedSeoObjectCategory = getSeoCategoryWithVariables(
    newSeoCategory,
    categoryName,
    subCategoryName,
    systemCount,
    country
  );

  const fixedSeoObjectSubCategory = getSeoCategoryWithVariables(
    newSeoSubCategory,
    categoryName,
    subCategoryName,
    systemCount,
    country
  );

  return {
    category: {
      ...fixedSeoObjectCategory,
      url: `${siteUrl}/${categorySlug}/`,
    },
    subCategory: {
      ...fixedSeoObjectSubCategory,
      url: subCategorySlug && `${siteUrl}/${categorySlug}/${subCategorySlug}/`,
    },
  };
}
